import React, { useEffect, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Puff } from "react-loader-spinner";

//  Account inner pages
import EditProfile from "../views/pages/account/EditProfile";
import Profile from "../views/pages/account/Profile";
import Register from "../views/pages/account/Register";

//  item inner pages
import ItemDetails from "../views/pages/item/ItemDetails";
import Upload from "../views/pages/item/Upload";
import UploadType from "../views/pages/item/UploadType";

// NftPages
import Collections from "../views/pages/NftPages/Collections";
import LiveAuctions from "../views/pages/auction/LiveAuctions";
import Marketplace from "../views/pages/NftPages/Marketplace";

// other pages
import { NFTDetails } from "../views/pages/item/NFTdetails";

// Route Specific
import CollectionForm from "../views/pages/collection/CollectionForm";
import CollectionDetails from "../views/pages/collection/CollectionDetails";
import Header from "../components/Header/Header";
import AirDrop from "../views/pages/item/Drop";
import CollectionDetailsDrop from "../views/pages/collection/CollectionDetailsDrop";
import AutionForm from "../views/pages/item/AuctionForm";
import OtherProfile from "../views/pages/account/OtherProfile";
import { AuctionDetails } from "../views/pages/auction/AuctionDetails";
import Footer from "../components/footer/Footer";
import Home from "../views/homes/Home1";
import BulkMint from "../views/pages/item/BulkMint";
import Aution from "../views/pages/item/Auction";
import LaunchPad from "../views/pages/launchpad/Launchpad";
import IDODetails from "../views/pages/launchpad/IDODetails";
import DraftNFTDetails from "../views/pages/item/DraftNFTDetails";
import DraftCollectionDetails from "../views/pages/item/DraftCollectionDetails";
import DeployFNFT from "../views/pages/item/DeployFNFT";
import FNFTDetailsTabs from "../components/fnft/FNFTDetailsTabs";
import AllFNFT from "../views/pages/FNFT/FNFT";
import NFTsForFNFT from "../views/pages/FNFT/NFTsForFNFT";
import AllNFTs from "../views/pages/NftPages/AllNFTs";
import FNFTHome from "../views/pages/FNFT/New/FNFTHome";
import LandingPage from "../views/pages/FNFT/New/FNFTLandingPage";
import FNFTMintingPage from "../views/pages/FNFT/New/FNFTMintingPage";
import FractionalizationPage from "../views/pages/FNFT/New/FractionalizationPage";
import FundraisingGoalPage from "../views/pages/FNFT/New/FundraisingGoalPage";
import CampaignCreationPage from "../views/pages/FNFT/New/CampaignCreationPage";
import TokenSalePage from "../views/pages/FNFT/New/TokenSalePage";
import InvestorEngagementPage from "../views/pages/FNFT/New/InvestorEngagementPage";
import TransparencyPage from "../views/pages/FNFT/New/TransparencyPage";
import SecondaryMarketPage from "../views/pages/FNFT/New/SecondaryMarketPage";
import AssetSelectionPage from "../views/pages/FNFT/New/AssetSelectionPage";
import NotificationPage from "../views/pages/notifications/transactions/Notifications";
import Notification from "../components/notifications/transactions/Notification";
import CampaignCreationForm from "../views/pages/FNFT/CampaignCreationForm";
import UserKyc from "../views/pages/account/UserKyc";
import MultiStepForm from "../views/pages/account/Kycs";
import DocxApp from "../views/pages/whitepaper/whitepaper";
const walletAddress = localStorage.getItem("WalletAddress");

const LoadingFallback = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ height: "100vh" }}
  >
    <Puff color="#36d7b7" height={100} width={100} />
  </div>
);

const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <div className="container text-center mt-5">
    <h2>Something went wrong!</h2>
    <pre style={{ color: "red" }}>{error.message}</pre>
    <button className="btn btn-primary" onClick={resetErrorBoundary}>
      Try again
    </button>
  </div>
);
const Routers = () => {
  useEffect(() => {
    const walletAddress = localStorage.getItem("WalletAddress");
    console.log("Wallet", walletAddress);
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Router>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            // Reset the state of your app here
            window.location.reload();
          }}
          onError={(error, errorInfo) => {
            // Log the error to an error reporting service
            console.error("Error:", error);
            console.error("Error Info:", errorInfo);
          }}
        >
          <Suspense fallback={<LoadingFallback />}>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/allNFTs" element={<AllNFTs />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/live-auctions" element={<LiveAuctions />} />
              <Route path="/docs" element={<DocxApp />} />
              <Route path="/launchpad" element={<LaunchPad />} />
              <Route path="/create-profile" element={<Register />} />{" "}
              {walletAddress && (
                <>
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/mint" element={<BulkMint />} />
                  <Route path="/auction" element={<AutionForm />} />
                  <Route path="/upload" element={<Upload />} />
                  <Route path="/drop" element={<AirDrop />} />
                  <Route path="/collectionAdd" element={<CollectionForm />} />
                  <Route path="/fnft" element={<NFTsForFNFT />} />
                  <Route path="/kyc" element={<UserKyc />} />
                  <Route path="/kycs" element={<MultiStepForm />} />
                  <Route
                    path="/editfnft/:collectionAddress/:tokenId"
                    element={<DeployFNFT />}
                  />
                  <Route
                    path="/deployfnft/:collectionAddress/:tokenId"
                    element={<DeployFNFT />}
                  />
                  <Route path="/AllFNFT" element={<AllFNFT />} />
                  <Route
                    path="/fnftDetails/:nftContract"
                    element={<FNFTDetailsTabs />}
                  />
                  {/* need to work */}
                  <Route path="/edit-profile" element={<EditProfile />} />
                  <Route path="/multiauction" element={<Aution />} />
                  <Route path="/upload-type" element={<UploadType />} />
                  <Route
                    path="/otherProfile/:walletAddress"
                    element={<OtherProfile />}
                  />
                  <Route path="/draftNFT/:id" element={<DraftNFTDetails />} />
                  <Route
                    path="/draftCollection/:id"
                    element={<DraftCollectionDetails />}
                  />
                </>
              )}
              <Route path="/idodetails/:id" element={<IDODetails />} />
              <Route path="/item-details/:id" element={<ItemDetails />} />
              <Route
                path="/nftdetails/:collectionAddress/:nftId"
                element={<NFTDetails />}
              />
              <Route
                path="/auction/details/:contractAddress/:auctionId"
                element={<AuctionDetails />}
              />
              <Route
                path="/collectionDetailsDrop/:collectionAddress"
                element={<CollectionDetailsDrop />}
              />
              <Route
                path="/collectionDetails/:collectionAddress"
                element={<CollectionDetails />}
              />
              {/*  Fundraising for FNFT */}
              <Route
                path="/create-campaign"
                element={<CampaignCreationForm />}
              />

              <Route path="/FNFThome" element={<FNFTHome />} />
              <Route path="/FNFThomePage" element={<LandingPage />} />
              <Route path="/asset-selection" element={<AssetSelectionPage />} />
              <Route path="/minting" element={<FNFTMintingPage />} />
              <Route
                path="/fractionalization"
                element={<FractionalizationPage />}
              /> 
              <Route
                path="/fundraising-goal"
                element={<FundraisingGoalPage />}
              />
              <Route
                path="/campaign-creation"
                element={<CampaignCreationPage />}
              />
              <Route path="/token-sale" element={<TokenSalePage />} />
              <Route
                path="/investor-engagement"
                element={<InvestorEngagementPage />}
              />
              <Route path="/transparency" element={<TransparencyPage />} />
              <Route
                path="/secondary-market"
                element={<SecondaryMarketPage />}
              />
              <Route path="/notifications" element={<NotificationPage />} />
            </Routes>
            <Footer />
          </Suspense>
        </ErrorBoundary>
      </Router>
    </>
  );
};

export default Routers;
